import { PRIZM_EMPTY_ARRAY } from '@prizm-ui/core';
import { PrizmMarkerHandler } from '../types/marker-handler';

export const PRIZM_DEFAULT_MARKER_HANDLER: PrizmMarkerHandler = (): [] => PRIZM_EMPTY_ARRAY;
